import React from 'react'
import { bool, string } from 'prop-types'
import { UserPortraitSelector } from '@fs/zion-portrait-selector'
import { useCurrentTemple } from '../../hooks/api'

export default function HeroCircle({ fallbackHeaderImage, type, loading, signedIn }) {
  let imageUrl = fallbackHeaderImage
  const templeData = useCurrentTemple({ loading, signedIn })
  const size = '200px'

  const imageStyle = {
    width: `${type === 'activities' ? 'inherit' : size}`,
    height: size,
    objectFit: 'cover',
    borderRadius: `${type === 'activities' ? '0%' : '50%'}`,
    backgroundColor: `${type === 'activities' ? 'transparent' : '#ffffff'}`,
    border: `${type === 'activities' ? 'none' : '3px solid #FFFFFF'}`,
  }

  function imageHeroConstructor(imageLink) {
    return (
      <div data-testid="hero-circle-testid">
        {imageLink && <img src={imageLink} style={imageStyle} alt="" role="presentation" />}
      </div>
    )
  }

  switch (type) {
    case 'temple':
      if (templeData?.imageUrl) {
        imageUrl = templeData.imageUrl
      }
      return imageHeroConstructor(imageUrl)
    case 'stories':
      return <UserPortraitSelector />
    default:
      return imageHeroConstructor(imageUrl)
    // do nothing
  }
}

HeroCircle.propTypes = {
  fallbackHeaderImage: string,
  type: string,
  loading: bool,
  signedIn: bool.isRequired,
}
